import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { stripAccountPrefix } from '../constants/permissions';

// Rutas de más específica a más genérica.
// La primera que matchee el pathname actual define el título de la sección.
const ROUTE_TITLES = [
  { pattern: '/landing', title: null },

  { pattern: '/auth/login', title: 'Iniciar sesión' },
  { pattern: '/auth/resetpassword', title: 'Restablecer contraseña' },
  { pattern: '/auth/confirmnewpassword/:email', title: 'Cambiar contraseña' },
  { pattern: '/auth/change-temporary-password', title: 'Cambiar contraseña temporal' },
  { pattern: '/auth/confirm/:email', title: 'Confirmar cuenta' },

  { pattern: '/home', title: 'Inicio' },
  { pattern: '/accounts/:clientId', title: 'Detalle de cuenta' },
  { pattern: '/accounts', title: 'Listado de cuentas' },
  { pattern: '/users', title: 'Listado de usuarios' },
  { pattern: '/platform/profiles', title: 'Perfiles genéricos' },
  { pattern: '/platform/audit', title: 'Auditoría' },
  { pattern: '/platform/incidents', title: 'Incidentes' },
  { pattern: '/products/virtual-agent/planes/new', title: 'Nuevo plan' },
  { pattern: '/products/virtual-agent/planes/:planId', title: 'Editar plan' },
  { pattern: '/products/virtual-agent/planes', title: 'Planes' },
  { pattern: '/products/virtual-agent/catalogo-voces', title: 'Catálogo de voces' },
  { pattern: '/products/virtual-agent', title: 'Agente Virtual' },
  { pattern: '/products/*', title: 'Productos' },
  { pattern: '/consumption', title: 'Consumo de Clientes' },

  { pattern: '/service/sms/reportes', title: 'Reportes de SMS' },
  { pattern: '/service/sms/consumos', title: 'Reporte de SMS' },
  { pattern: '/service/sms', title: 'SMS' },

  { pattern: '/service/call-blasting/consumos', title: 'Consumos de Call Blasting' },
  { pattern: '/service/call-blasting/reportes', title: 'Reportes de Call Blasting' },
  { pattern: '/service/call-blasting', title: 'Call Blasting' },

  { pattern: '/service/virtual-agent/voz/flows/*', title: 'Administración de flujos' },
  { pattern: '/service/virtual-agent/voz/conversaciones/*', title: 'Conversaciones' },
  { pattern: '/service/virtual-agent/voz/reportes/*', title: 'Reportería' },
  { pattern: '/service/virtual-agent/voz/consumos', title: 'Consumos' },
  { pattern: '/service/virtual-agent/voz/*', title: 'Agente Virtual - Voz' },

  { pattern: '/service/virtual-agent/chat/flows/*', title: 'Administración de flujos' },
  { pattern: '/service/virtual-agent/chat/consumos', title: 'Consumos' },
  { pattern: '/service/virtual-agent/chat/reportes', title: 'Reportes' },
  { pattern: '/service/virtual-agent/chat/encuestas/crear/*', title: 'Crear encuesta' },
  { pattern: '/service/virtual-agent/chat/encuestas/reporteria', title: 'Reportería de encuestas' },
  { pattern: '/service/virtual-agent/chat/encuestas', title: 'Encuestas' },
  { pattern: '/service/virtual-agent/chat/seguimiento-pasos', title: 'Seguimiento de pasos' },
  { pattern: '/service/virtual-agent/chat/*', title: 'Agente Virtual - Chat' },
  { pattern: '/service/virtual-auditors', title: 'Auditores virtuales' },
  { pattern: '/service/virtual-agent', title: 'Agente Virtual' },

  { pattern: '/service/agent-manager/reportes', title: 'Reportes de Agent Manager' },
  { pattern: '/service/agent-manager/contactabilidad', title: 'Contactabilidad de Agent Manager' },
  { pattern: '/service/agent-manager/colas', title: 'Administración de Campañas' },
  { pattern: '/service/agent-manager/agentes', title: 'Agentes de Agent Manager' },
  { pattern: '/service/agent-manager', title: 'Agent Manager' },

  { pattern: '/service/portafolio', title: 'Portafolio' },
  { pattern: '/service/integraciones', title: 'Integración' },
  { pattern: '/service/chat-bot', title: 'Chat-Bot' },
  { pattern: '/service/agendador', title: 'Agendador' },
  { pattern: '/service/recepcionista', title: 'Recepcionista virtual' },
  { pattern: '/service/phone-validator/properties', title: 'Propiedades de contacto' },
  { pattern: '/service/phone-validator', title: 'Phone Validator' },
  { pattern: '/service/social-media/inbox-hub', title: 'Bandeja de entrada' },
  { pattern: '/service/social-media/inbox/:conversationId', title: 'Bandeja de entrada' },
  { pattern: '/service/social-media/inbox', title: 'Bandeja de entrada' },
  { pattern: '/service/social-media/inbox-report', title: 'Reportería de la bandeja' },
  { pattern: '/service/social-media/typification-catalog', title: 'Catálogo de tipificación' },
  { pattern: '/service/social-media/widget/list', title: 'Widgets' },
  { pattern: '/service/social-media/widget/report', title: 'Reportería del widget' },
  { pattern: '/service/social-media/widget/limits', title: 'Límites del widget' },
  { pattern: '/service/social-media/widget/*', title: 'Widget web' },
  { pattern: '/service/social-media/widget', title: 'Widget web' },
  { pattern: '/service/social-media', title: 'Social Media' },

  { pattern: '/service/nthw-templates/create', title: 'Crear Plantilla' },
  { pattern: '/service/nthw-templates/:templateId/edit', title: 'Editar Plantilla' },
  { pattern: '/service/nthw-templates', title: 'WhatsApp' },

  { pattern: '/service/whatsapp/phones/:systemNumber/template/:templateId', title: 'Detalle de plantilla' },
  { pattern: '/service/whatsapp/phones/:systemNumber', title: 'Detalle de número' },
  { pattern: '/service/whatsapp/phones', title: 'Mis números y plantillas' },
  { pattern: '/service/whatsapp/active-chats/:conversationId', title: 'Conversaciones activas' },
  { pattern: '/service/whatsapp/active-chats', title: 'Conversaciones activas' },
  { pattern: '/service/whatsapp/historical-chats/:conversationId', title: 'Historial de conversaciones' },
  { pattern: '/service/whatsapp/historical-chats', title: 'Historial de conversaciones' },
  { pattern: '/service/whatsapp/bulk-sends/new', title: 'Nuevo envío' },
  { pattern: '/service/whatsapp/bulk-sends/:batchId', title: 'Detalle del envío' },
  { pattern: '/service/whatsapp/bulk-sends', title: 'Envíos masivos' },
  { pattern: '/service/whatsapp/metrics/:systemNumber', title: 'Métricas' },
  { pattern: '/service/whatsapp/metrics/*', title: 'Métricas' },
  { pattern: '/service/whatsapp/catalog', title: 'Catálogo' },
  { pattern: '/service/whatsapp/limits', title: 'Límites' },
  { pattern: '/service/whatsapp', title: 'WhatsApp' },
  { pattern: '/service/whatsapp/*', title: 'WhatsApp' },
];

function resolveTitle(pathname) {
  const match = ROUTE_TITLES.find(({ pattern }) =>
    matchPath({ path: pattern, end: true }, pathname)
  );
  return match ? match.title : null;
}

export default function usePageTitle() {
  const location = useLocation();

  useEffect(() => {
    const pathname = stripAccountPrefix(location.pathname);
    const title = resolveTitle(pathname);
    document.title = title ? `${title} | Nua` : 'Nua';
  }, [location.pathname]);
}
